import { fade, Theme } from '@material-ui/core';
import { CSSProperties } from 'react';

export const getContainerStyle = (
  selected: boolean,
  { palette }: Theme
): CSSProperties => ({
  backgroundColor: selected ? palette.primary.main : undefined,
});

export const getVerticalDividerStyle = (
  selected: boolean,
  { palette }: Theme
): CSSProperties => ({
  backgroundColor: selected ? fade(palette.common.white, 0.2) : undefined,
});

export const getFontColorStyle = (
  selected: boolean,
  { palette }: Theme
): CSSProperties => ({
  color: selected ? palette.common.white : undefined,
});
